import {
  Breadcrumb as ChakraBreadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useMatches, useParams } from "react-router-dom";
import { breadcrumbList } from "../plugin/constants";
import { useAssistance } from "../plugin/hooks";

const Breadcrumb = ({ ...props }) => {
  const { t } = useTranslation();
  const { beneficiaryId } = useParams();
  const matches = useMatches();
  const crumbsLength = matches.filter((match) => match.handle?.crumb).length;
  const { assistance } = useAssistance()

  return (
    <ChakraBreadcrumb gap={4} separator={null} {...props}>
      {breadcrumbList.map((crumb, index) => (
        <BreadcrumbItem
          color={index === crumbsLength - 1 ? "black" : "inherit"}
          fontWeight={index === crumbsLength - 1 ? "bold" : "normal"}
          key={crumb.label}
        >
          {(index === 1 && assistance?.assistance_request_id) ? (
            <BreadcrumbLink as={Link} to={crumb.link(assistance?.assistance_request_id)}>
              {t(crumb.label)}
            </BreadcrumbLink>
          ) : (index > crumbsLength - 1) ? (
            <Trans>{crumb.label}</Trans>
          ) : (
            <BreadcrumbLink as={Link} to={crumb.link(beneficiaryId)}>
              {t(crumb.label)}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
      ))}
    </ChakraBreadcrumb>
  );
};

export default React.memo(Breadcrumb);
